<script lang="ts">
	import AdformToggle from '../../../../containers/AdformToggleButton.svelte';
	import { createEventDispatcher } from 'svelte';

	let dispatch = createEventDispatcher();
	function dispatchDeleted() {
		dispatch('refresh');
	}

	export let row: any;
	export let mixArray = [];
</script>

{#if !mixArray.includes(row.name)}
	<AdformToggle
		id={row.id}
		name={row.name}
		isActive={row.sendToAdForm}
		on:dispatchSuccess={dispatchDeleted}
	/>
{/if}
